import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

// ✅ Get service invoices (with filters / pagination)
export const getServiceInvoices = async (params = {}) => {
  const { data } = await apiClient.get("/service-invoices", { params })
  return data
}

// ✅ Get single service invoice by ID
export const getServiceInvoiceById = async id => {
  const { data } = await apiClient.get(`/service-invoices/${id}`)
  return data
}

// ✅ Create service invoice
export const createServiceInvoice = async payload => {
  const { data } = await apiClient.post("/service-invoices", payload)
  return data
}

// ✅ Update service invoice
export const updateServiceInvoice = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/service-invoices/${id}`, payload)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteServiceInvoice = async id => {
  const { data } = await apiClient.delete(`/service-invoices/${id}`)
  return data
}

// ✅ Toggle whether previous due prints on the invoice PDF
export const toggleServiceInvoicePreviousDue = async id => {
  const { data } = await apiClient.patch(
    `/service-invoices/${id}/toggle-previous-due`
  )
  return data
}

// ✅ Download / open the invoice PDF
export const getServiceInvoicePdfById = (id, setLoading) => {
  return downloadAndOpenFile({
    url: `/service-invoices/${id}/pdf`,
    mimeType: "application/pdf",
    openInNewTab: true,
    onStart: () => setLoading?.(true),
    onEnd: () => setLoading?.(false),
  })
}
